import types from '../mutation-types'

const state = {
  graph: {}
}

const getters = {
  getGraphInfo: (state) => {
    return state.graph
  }
}

const actions = {
  saveGraphInfo({commit, state}, graph) {
    commit(types.GRAPH_INFO, graph)
  }
}

const mutations = {
  [types.GRAPH_INFO](state, graph) {
    state.graph = graph
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/graph.js